import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styles from "./OnboardingModal.module.css";
import { useHaptic } from "../hooks/useHaptic";

const ONBOARDING_KEY = "burntap_v1_onboarded";

export function isOnboarded(): boolean {
  return localStorage.getItem(ONBOARDING_KEY) === "1";
}

function markOnboarded() {
  localStorage.setItem(ONBOARDING_KEY, "1");
}

type Slide = { visual: string; title: string; body: React.ReactNode };

const SLIDES: Slide[] = [
  {
    visual: "🔥❄️",
    title: "BurnTap — передбач BTC за 5 секунд",
    body: (
      <>
        Гра проти ринку. <span className={styles.highlight}>Без реальних грошей</span> —
        лише азарт, аналіз та GT токени.
      </>
    ),
  },
  {
    visual: "👆",
    title: "Тапни на полум'я — отримай результат",
    body: (
      <>
        <span className={styles.highlight}>Червоне вгорі</span> → ставка на ріст.{" "}
        <span className={styles.highlight}>Синє внизу</span> → ставка на падіння.
        Чекай 5 секунд. Все.
      </>
    ),
  },
  {
    visual: "💎",
    title: "Більший ризик — більше GT токенів",
    body: (
      <>
        All-in виграш = <span className={styles.highlight}>до 25 GT</span> за раунд.
        Накопичуй токени — витрачай на бусти або чекай TGE.
      </>
    ),
  },
];

type Props = { onDone: () => void };

export function OnboardingModal({ onDone }: Props) {
  const [idx, setIdx] = useState(0);
  const haptic = useHaptic();
  const isLast = idx === SLIDES.length - 1;

  const next = () => {
    haptic.select();
    if (isLast) {
      markOnboarded();
      onDone();
    } else {
      setIdx((i) => i + 1);
    }
  };

  const slide = SLIDES[idx]!;

  return (
    <div className={styles.overlay}>
      <div className={styles.slides}>
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={idx}
            className={styles.slide}
            initial={{ x: 60, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -60, opacity: 0 }}
            transition={{ duration: 0.28, ease: [0.2, 0.8, 0.2, 1] }}
          >
            <div className={styles.visual}>{slide.visual}</div>
            <div className={styles.slideTitle}>{slide.title}</div>
            <div className={styles.slideBody}>{slide.body}</div>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className={styles.footer}>
        <div className={styles.dots}>
          {SLIDES.map((_, i) => (
            <div
              key={i}
              className={`${styles.dot} ${i === idx ? styles.dotActive : ""}`}
            />
          ))}
        </div>
        <button type="button" className={styles.cta} onClick={next}>
          {isLast ? "Почати гру 🔥" : "Далі"}
        </button>
      </div>
    </div>
  );
}
